<template>
  <div class="popupFrameworkRootBox" ref="popupFrameworkRootBox">
    <div class="popupFrameworkContentBox" ref="popupFrameworkContentBox" :style="{'--hoverBagColor':hoverBagColor}">
      <im-frame-drag @down="onmousedownFun" @up="onmouseupFun" :min-width="200" :min-height="300" :drag-el="$refs.header"></im-frame-drag>
      <header ref="header" role="popupFrameworkHeader">
        <div role="title" @dblclick="titleClick()">
          <el-dropdown trigger="hover" @command="nextLayer">
            <i v-show="logo" :class="logo || 'el-icon-monitor'" title="调节层级"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-place" command="2">到顶层</el-dropdown-item>
              <el-dropdown-item icon="el-icon-refresh-left" command="0">还原</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <slot name="title">
            <span>{{ title }}</span>
          </slot>
        </div>
        <div role="menu" ref="menuBox">
          <menu v-for="(item,index) in menus" v-if="!hideMenu.includes(index)" :key="index" :title="item.title()"
                @mousedown.prevent.stop="item.click()" :role="item.role" v-show="item.show()">
            <i :class="item.css()"></i>
          </menu>
          <slot name="menu"></slot>
        </div>
      </header>
      <main
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        style="background-repeat: no-repeat;background-position: center;background-size: 100%"
        :style="{background:blackboardMode?'#188d68':null}"
      >
        <img v-if="mainBackgroundImage" :src="mainBackgroundImage"
             style="width: 100%;height: 100%;position: absolute;left: 0;top: 0"/>
        <slot>
          <i class="el-icon-loading"></i>
        </slot>
      </main>
    </div>
  </div>
</template>

<script>
import ImFrameDrag from "@/views/szrt_revision/teachingDetail/list/classroom/imcomponents/imFrameDrag";
export default {
  name: "popupFramework",
  components: {ImFrameDrag},
  props: {
    minWidth: {//弹窗最小尺寸(宽度)
      type: Number,
      default: 200
    },
    minHeight: {//弹窗最小尺寸(高度)
      type: Number,
      default: 100
    },
    fixedHeight: {//弹窗固定高度
      type: Number,
      default: 0
    },
    fixedWidth: {//弹窗固定宽度
      type: Number,
      default: 0
    },
    startEl: {//弹窗缩放位置(点)
      type: Element,
      default: null
    },
    endEl: {//弹窗缩放位置(点)
      type: Element,
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    logo: {
      type: String,
      default: ''
    },
    defaultZIndex: {//默认层级
      type: [String, Number],
      default: '2'
    },
    transition: {
      type: String,
      default: 'all .3s'
    },
    hoverBagColor: {
      type: String,
      default: '#44c9ff'
    },
    loading: {
      type: Boolean,
      default: false
    },
    hideMenu: {
      type: Array,
      default: () => ([])
    },
    blackboardMode: {//黑板模式
      type: Boolean,
      default: false
    },
    forbidZoom: { //禁止缩放
      type: Boolean,
      default: false
    },
    mainBackgroundImage: {
      type: String,
      default: ''
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.init()
        } else {
          this.hideRoot()
        }
      },
      immediate: true
    },
  },
  computed: {
    isFixed() {
      return this.fixedWidth || this.fixedHeight
    }
  },
  data() {
    return {
      menus: [
        {
          title: () => '关闭',
          css: () => 'iconfont icon-yuyinguanbi',
          click: () => this.close(),
          show: () => true,
          role: 'close'
        },
        {
          title: () => this.isMaximize ? '还原' : '最大化',
          css: () => `iconfont ${this.isMaximize ? 'icon-zuixiaohua' : 'icon--zuidahua'}`,
          click: () => this.zoom(),
          show: () => !this.isFixed,
          role: null
        },
        {
          title: () => '最小化',
          css: () => 'iconfont icon-zuixiaohua-2',
          click: () => this.minimize(),
          show: () => !this.isFixed,
          role: null
        },
      ],
      windowStatus: {//窗口状态
        maximize: '0',//最大化
        minimize: '1',//最小化
        close: '2',//关闭
      },
      that: this,
      isMaximize: false,
      popupFrameworkContentBox: {
        top: '0',
        left: '0',
      },
      onmouseup: true
    }
  },
  methods: {
    hideRoot() {
      this.$nextTick(() => {
        this.setTransformOrigin()
        this.minimize()
      })
    },
    /**
     * 初始化
     */
    init() {
      this.initContentBoxStyle()
      this.initMenuBoxStyle()
      this.$nextTick(() => this.$emit('init'))
    },
    /**
     * 初始化ContentBox样式
     */
    initContentBoxStyle() {
      setTimeout(()=>{
        const popupFrameworkRootBox = this.$refs.popupFrameworkRootBox
        popupFrameworkRootBox.style.transform = 'scale(1)'
        const popupFrameworkContentBox = this.$refs.popupFrameworkContentBox
        if (this.isFixed) {
          if (this.fixedWidth) {
            popupFrameworkContentBox.style.width = this.fixedWidth + 'px'
          }
          if (this.fixedHeight) {
            popupFrameworkContentBox.style.height = this.fixedHeight + 'px'
          }
          if (this.fixedWidth && this.fixedHeight) {
            this.$refs.dragBox.style.resize = 'none';
          }
        }
        popupFrameworkContentBox.style.opacity = '1'
        popupFrameworkContentBox.style.transform = 'scale(1)'
      },50)
    },
    /**
     * 初始化menuBox样式
     */
    initMenuBoxStyle() {
      // if (Array.isArray(this.hideMenu)){
      //   this.$nextTick(()=>this.menus = [...this.menus].filter((item,index)=>!this.hideMenu.includes(index)))
      // }
      const menu = this.$refs.menuBox
      const menus = menu.querySelectorAll('menu')
      menu.style.setProperty('grid-template-columns', `repeat(${menus.length}, 1fr)`)
    },
    /**
     * 关闭
     */
    close() {
      this.minimize(true)
    },
    /**
     * 双击标题
     */
    titleClick() {
      this.zoom()
    },
    /**
     * 缩放（最大化/还原最初状态）
     */
    zoom() {
      const popupFrameworkContentBox = this.$refs.popupFrameworkContentBox
      popupFrameworkContentBox.style.transition = this.transition;
      this.isMaximize ? this.reduction() : this.maximize()
    },
    /**
     * 最大化
     * @param popupFrameworkContentBox
     */
    maximize() {
      const popupFrameworkContentBox = this.$refs.popupFrameworkContentBox
      const styles = getComputedStyle(popupFrameworkContentBox)
      this.isMaximize = true
      this.popupFrameworkContentBox.top = styles.top
      this.popupFrameworkContentBox.left = styles.left
      this.popupFrameworkContentBox.width = styles.width
      this.popupFrameworkContentBox.height = styles.height
      popupFrameworkContentBox.style.top = '0'
      popupFrameworkContentBox.style.left = '0'
      popupFrameworkContentBox.style.width = '100%'
      popupFrameworkContentBox.style.height = '100%'
      this.$emit('popupResize', this.windowStatus.maximize, this.windowStatus)
    },
    /**
     * 最大化之后的还原
     */
    reduction() {
      if (this.isMaximize) {
        this.isMaximize = false
        const popupFrameworkContentBox = this.$refs.popupFrameworkContentBox
        popupFrameworkContentBox.style.top = this.popupFrameworkContentBox.top
        popupFrameworkContentBox.style.left = this.popupFrameworkContentBox.left
        popupFrameworkContentBox.style.width = this.popupFrameworkContentBox.width
        popupFrameworkContentBox.style.height = this.popupFrameworkContentBox.height
      }
    },
    /**
     * 最小化
     */
    minimize(isClosed) {
      const popupFrameworkRootBox = this.$refs.popupFrameworkRootBox
      const popupFrameworkContentBox = this.$refs.popupFrameworkContentBox
      popupFrameworkRootBox.style.zIndex = '9999'
      popupFrameworkContentBox.style.transform = 'scale(0)'
      popupFrameworkContentBox.style.opacity = '0'
      this.setTransformOrigin()
      this.$emit('update:visible', false)
      this.$emit('popupResize', isClosed ? this.windowStatus.close : this.windowStatus.minimize, this.windowStatus)

      setTimeout(() => {
        popupFrameworkRootBox.style.zIndex = this.defaultZIndex
        popupFrameworkRootBox.style.transform = 'scale(0)'
        popupFrameworkRootBox.style.opacity = '1'
      }, 350)
    },
    /**
     * 设置消失位置
     */
    setTransformOrigin() {
      const popupFrameworkContentBox = this.$refs.popupFrameworkContentBox
      popupFrameworkContentBox.style.transition = this.transition;
      if (this.startEl || this.endEl) {
        let contentBoxRect = popupFrameworkContentBox.getBoundingClientRect();
        let elRect = this.endEl ? this.endEl.getBoundingClientRect() : this.startEl.getBoundingClientRect();
        let x = elRect.x - contentBoxRect.x + elRect.height / 2
        let y = elRect.y - contentBoxRect.y + elRect.width / 2
        popupFrameworkContentBox.style.transformOrigin = `${x}px ${y}px`
      }
    },
    nextLayer(command) {
      const popupFrameworkRootBox = this.$refs.popupFrameworkRootBox
      const styles = getComputedStyle(popupFrameworkRootBox)
      console.log('command', command, styles['z-index'])
      if (command === '0') {
        console.log('还原')
        popupFrameworkRootBox.style.zIndex = this.defaultZIndex
      } else if (command === '2') {
        console.log('到顶层')
        popupFrameworkRootBox.style.zIndex = '9999'
      } else if (command === '1') {
        console.log('加一')
        popupFrameworkRootBox.style.zIndex = `${Number(styles['z-index']) + 1}`
      } else if (command === '-1') {
        popupFrameworkRootBox.style.zIndex = `${Number(styles['z-index']) - 1}`
        console.log('减一')
      }
    },
    /**
     * 指令创建
     * @returns {Element}
     */
    getApp() {
      return document.querySelector('#app')
    },
    /**
     * 按下鼠标
     * @param app
     * @returns {default.methods.$refs.popupFrameworkContentBox}
     */
    onmousedownFun() {
      const iframes = [...app.querySelectorAll('iframe')]
      iframes.forEach(item => item.style.setProperty('pointer-events', 'none'))
    },
    /**
     * 抬起鼠标
     * @param app
     */
    onmouseupFun() {
      const iframes = [...app.querySelectorAll('iframe')]
      iframes.forEach(item => item.style.setProperty('pointer-events', 'auto'))
    },
  },
}
</script>

<style scoped lang="scss">
@import url('../../../../../../src/assets/fonts/os/iconfont.css');

.popupFrameworkRootBox {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  pointer-events: none !important;
  opacity: 0;
  .popupFrameworkContentBox {
    width: 60%;
    height: 80%;
    position: fixed;
    background: rgba(35, 34, 34, 0.12);
    backdrop-filter: blur(5px);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    pointer-events: auto !important;
    left: 20%;
    top: 10%;

    & > header {
      box-sizing: border-box;
      height: 30px;
      width: 100%;
      border-radius: 4px 4px 0 0;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;

      & > div[role=title] {
        display: flex;
        align-items: center;
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        height: inherit;
        cursor: move;

        span {
          margin-left: 5px;
          color: black;
          font-size: 0.8em;
        }

        i {
          padding: 8px;
          cursor: pointer;
        }
      }

      & > div[role=menu] {
        height: 100%;
        display: grid;
        grid-template-rows: 100%;
        grid-template-columns: repeat(3, 1fr);
        justify-items: center;
        align-items: center;
        align-content: center;
        justify-content: center;
        grid-auto-flow: revert;
        direction: rtl;
        gap: 2px;

        & > menu {
          width: 40px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        & > menu:hover {
          background-color: #D7D7D7;
        }

        & > menu[role=close]:hover {
          background-color: #f56c6c;
          color: white;
        }
      }
    }

    & > main {
      flex: 1;
      width: calc(100% - 4px);
      background-color: #ffffff;
      border-radius: 0 0 4px 4px;
      margin: 0 2px 2px 2px;
      display: grid;
      overflow-y: auto;
      position: relative;
      background-size: 100%;
      background-position: center;
      background-repeat: no-repeat;

      & > *:first-child {
        width: 100%;
        height: 100%;
        z-index: 2;
      }
    }
  }

  ::-webkit-scrollbar {
    display: none;
  }

  .popupFrameworkContentBox:hover {
    background: var(--hoverBagColor);
  }

  .popupFrameworkContentBox:hover header > div[role=title] > span {
    color: white;
  }

  .popupFrameworkContentBox:hover header > div[role=title] i {
    color: white;

  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/teachingDetail/list/classroom/popupFramework.vue